import React from 'react';
import RightAPI from '../api/RightAPI';
import { RightAPIResponse } from '../api/right.model';

function useRolesList() {
  const { data: roles, ...rest } = RightAPI.useGetRolesQuery(undefined);

  const data = React.useMemo(
    () => Object.values(roles?.entities ?? {}) as RightAPIResponse[],
    [roles]
  );
  return {
    data,
    ...rest,
  };
}

export default useRolesList;
